@reference "@glow/tailwind-config/reference.css";

.container {
  @apply flex;
  @apply gap-4;
  @apply h-6;
  @apply items-center;
  @apply justify-items-center;
}

.progressWrapper {
  @apply box-border;
  @apply border-solid;
  @apply border-emphasis-low;
  @apply bg-white;
  @apply rounded-full;
  @apply w-full;
  @apply h-2;
}

.progressBar {
  @apply bg-primary-500;
  @apply h-full;
  @apply rounded-full;
  @apply border-emphasis-low;
}

.percentText {
  @apply text-emphasis-medium;
  @apply text-base;
}
